import React, { useState } from "react";
import { HStack, Spinner, Switch, Text } from "@chakra-ui/react";
import useNotification from "../../../utils/useNotification";
import services from "../services";

interface SingleInvoiceToggleProps {
  orderId: string;
  isChecked: boolean;
  isLocked: boolean;
  refetchAllOrders: () => void;
}

export const SingleInvoiceToggle: React.FC<SingleInvoiceToggleProps> = ({
  orderId,
  isChecked,
  isLocked,
  refetchAllOrders,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [localChecked, setLocalChecked] = React.useState(isChecked);
  const toast = useNotification();

  React.useEffect(() => {
    setLocalChecked(isChecked);
  }, [isChecked]);

  const handleToggle = async () => {
    if (isLocked) {
      toast({
        title: "Cannot change",
        description: isChecked
          ? "Single Invoice cannot be changed after single invoice has been generated."
          : "Single Invoice cannot be changed after a confirmed order has been created.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsLoading(true);
    const targetState = !localChecked;
    try {
      await services.updateOrder(orderId, {
        billingDetails: {
          isSingleGaraazInvoiceRequired: targetState,
        },
      });
      
      setLocalChecked(targetState);
      
      toast({
        title: "Updated",
        description: targetState
          ? "Marked the enquiry for single invoice required."
          : "Unmarked the enquiry for single invoice required.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      refetchAllOrders();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "Failed to update Single Invoice.";
      toast({
        title: "Error",
        description: errorMessage,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HStack
      spacing={2}
      align="center"
      bg="#F5F8FF"
      border="1px solid"
      borderColor="#D2E3FF"
      borderRadius="md"
      px={1}
      py={0.5}
    >
      {isLoading ? (
        <Spinner size="xs" color="blue.500" />
      ) : (
        <Switch
          size="sm"
          colorScheme="blue"
          isChecked={localChecked}
          isDisabled={isLocked}
          onChange={handleToggle}
        />
      )}
      <Text fontSize="x-small" color="#2B5CA6" fontWeight="bold" textTransform="uppercase" whiteSpace="nowrap">
        SINGLE INVOICE
      </Text>
    </HStack>
  );
};
